import React from "react";
import { action, useDsp } from "app/store";
import { ReactComponent as IconSettings } from "assets/svg/icon-settings.svg";

export const ButtonRatingFilter = () => {
  const dispatch = useDsp();
  const filterShow = () => dispatch(action.fRatingShow());

  return (
    <button
      type="button"
      className="btn-reset button-mobile-menu"
      onClick={filterShow}
    >
      <IconSettings />
    </button>
  );
};
